import * as Configuration from '../../../app.constants.js';

UsersController.$inject = ['$scope', 'company', 'TopToolbarFactory', '$state'];
export function UsersController($scope, company, TopToolbarFactory, $state) {
  init();

  function init() {
    TopToolbarFactory.setTitleTranslation('admin/users/title', $scope);
    $scope.iframeUrl = Configuration.constants.baseUrl + company.id +
      '/parameters/users/ifr-content';

    // Redirect to new users page
    $state.go('auth.alcmeon.fuse.users-roles', {
      'companyId': company.id
    });
  }
}
